module.exports = __webpack_public_path__ + "img/ios-1.095e4623.png";